import { defineStore } from 'pinia'
import { retrieveLanguageList } from '@/api/user'

export const useLanguageStore = defineStore('bestdealer-language', () => {
  const current = ref('en')
  const list = ref([])

  const init = async () => {
    const { code, data } = await retrieveLanguageList()
    if (code === 200) {
      list.value = data

      if (!data.find(item => item.language === current.value)) {
        current.value = data[0].language
      }
    }
  }

  const update = (language) => {
    current.value = language
  }

  return { current, list, update, init }
}, {
  persist: true,
  sync: true
})
